import React from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

export const DateTimeField = (props) => {
    const {
        input,
        meta: {touched, error},
    } = props;

    return (
        <div>
            <DatePicker
                selected={input.value || ''}
                onChange={input.onChange}
                dateFormat="MMMM d, yyyy h:mm aa"
                timeFormat="HH:mm"
                timeIntervals={15}
                showTimeSelect={true}
                shouldCloseOnSelect={true}
                timeCaption="time"
                minDate={new Date()}
                showDisabledMonthNavigation
            />
            <br />
            {touched && error && <span className="errMsg"> {error} </span>}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/fields/field_datetime.js